import { Api } from "../config/request";

export default {
  getDriverMedalsDetails(queryParams) {
    return Api.get(`/rider_medals_dashboard${queryParams}`);
  },
  getDriverMetaData(queryParams) {
    return Api.get(`/driver/basic-info${queryParams}`);
  },
};
